import { getLocale } from '@actual-app/core/shared/locale';

import { useGlobalPref } from './useGlobalPref';

/** The user's language code (BCP 47), French by default. */
export function useLanguage() {
  const [language] = useGlobalPref('language');
  // MTXbudget is a French application: dates in French unless another
  // language is chosen in the settings (same rule as the labels, see i18n.ts).
  return language || 'fr-CA';
}

export function useLocale() {
  return getLocale(useLanguage());
}
